const caseInsensitiveCompare = (text = '', other = ''): boolean => {
    if (typeof text !== 'string' || typeof other !== 'string') {
        return false;
    }
    return text.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
};

export default caseInsensitiveCompare;
